<template>
	<div class="main">
		<ul id="dormitoryTypeNav" class="nav nav-tabs" role="tablist" v-show="isAdmin('stay')">
			<li class="" data-apply-type="N" role="presentation" v-if="normalIsOpen">
				<a data-toggle="tab" @click="selectionDoemitoryType('N')">一般宿舍</a>
			</li>
			<li class="" data-apply-type="V" role="presentation" v-if="vacationIsOpen">
				<a data-toggle="tab" @click="selectionDoemitoryType('V')">寒暑假宿舍</a>
			</li>
			<li class="" data-apply-type="S" role="presentation" v-if="specialIsOpen">
				<a data-toggle="tab" @click="selectionDoemitoryType('S')">特殊原因宿舍</a>
			</li>
		</ul>
		<section class="panel panel-default" style="margin-bottom: 0px;" v-if="isAdmin('stay')">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4" v-if="dormitoryType == 'N'">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value" :selected="index == 0">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4" v-else>
								<label class="col-md-4">學年</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>
                            <div class="col-md-4">
								<label class="col-md-4">學號</label>
								<div class="col-md-8">
									<input type="text" v-model="account" />
								</div>
							</div>

						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">宿舍</label>
								<div class="col-md-8">
									<input type="text" v-model="bedFloor" />
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">寢室</label>
								<div class="col-md-8">
									<input type="text" v-model="bedRoom" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-offset-4 col-md-4 ">
							<div class="col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div id="dormitoryTypeContent" class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
			<div class="row form-group">
				<div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">

					<button class="btn btn-danger hidden-xs" v-if="sessionData.accountType == 'ADM'" @click="exportBankText">銀行檔匯出</button>
					<button class="btn btn-danger btn-block visible-xs" v-if="sessionData.accountType == 'ADM'" @click="exportBankText">銀行檔匯出</button>

					<button class="btn btn-danger hidden-xs" @click="exportExcel">資料匯出</button>
					<button class="btn btn-danger btn-block visible-xs" @click="exportExcel">資料匯出</button>
					<label for="fileV" class="btn btn-danger hidden-xs">資料匯入</label>
					<label for="fileV" class="btn btn-danger btn-block visible-xs">資料匯入</label>
					<input id="fileV" ref="fileV" name="file" type="file" value accept=".xls, .xlsx" @change="uploadFile($event)" style="display: none" />

				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
				<table class="table table-no-more table-bordered table-striped mb-none" style="width:100% !important;">
					<thead>
						<tr v-if="sessionData.accountType === 'STU'">
							<th class="text-center" style="width:9%">申請類別</th>
							<th class="text-center" style="width:4%">學期</th>
							<th class="text-center" style="width:9%">學制</th>
							<th class="text-center" style="width:12%">系科年級</th>
							<th class="text-center" style="width:6%">學生狀態</th>
							<th class="text-center" style="width:8%">學號</th>
							<th class="text-center" style="width:7%">姓名</th>
							<th class="text-center" style="width:6%">身分別</th>
							<th class="text-center" style="width:8%">分配床位</th>
							<th class="text-center" style="width:8%">繳費狀態</th>
              <th class="text-center" style="width:5%">繳費金額</th>
							<th class="text-center" style="width:6%"></th>
							<th class="text-center" style="width:6%"></th>
							<th class="text-center" style="width:6%"></th>
						</tr>
						<tr v-if="isAdmin('stay')">
							<th class="text-center" style="width:8%">申請類別</th>
							<th class="text-center" style="width:5%">學期</th>
							<th class="text-center" style="width:10%">學制</th>
							<th class="text-center" style="width:15%">系科年級</th>
							<th class="text-center" style="width:6%">學生狀態</th>
							<th class="text-center" style="width:8%">學號</th>
							<th class="text-center" style="width:7%">姓名</th>
							<th class="text-center" style="width:6%">身分別</th>
							<th class="text-center" style="width:15%">分配床位</th>
							<th class="text-center" style="width:8%">繳費狀態</th>
              <th class="text-center" style="width:6%">繳費金額</th>
              <th class="text-center" style="width:8%"></th>
						</tr>
					</thead>
					<tbody v-for="(item, index) in roomApplyList.rows" :key="index">
						<tr>
							<td class="text-center" data-title="申請類別">{{getDormitoryTypeStr(item.dormitoryType)}}</td>
							<td class="text-center" data-title="學期">{{item.smtr}}</td>
							<td class="text-center" data-title="學制">{{item.deptSsymStr}}</td>
							<td class="text-center" data-title="系科年級">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
							<td class="text-center" data-title="學生狀態">{{item.stateStr}}</td>
							<td class="text-center" data-title="學號">{{item.account}}</td>
							<td class="text-center" data-title="姓名">{{item.name}}</td>
							<td class="text-center" data-title="身分別">{{item.stuIdentityStr}}</td>
							<td class="text-center" data-title="分配床位" >
								<span v-if="item.bedRoom !== null">{{item.bedFloor}}-{{item.bedRoom}}-{{item.bed}}<br/>{{item.bedCategory}}</span>
								<select name="bed" :id="'select_'+index" @change="changeBed(item, $event)" class="form-control" v-else-if="isAdmin('stay') && item.quitProve === null">
									<option selected value="">請選擇</option>
									<option v-for="(bed,key) in bedList" :key="key" :id="'bedValue_'+key" :value="bed.id" >
										{{bed.bedFloor}}{{bed.bedRoom}}-{{bed.bed}}-{{bed.bedCategory}}
									</option>
								</select>
							</td>
							<td class="text-center" data-title="繳費狀態" >
								<a :href="$baseUrl + '/upload/' + item.quitProve" target="_blank" style="color: #337ab7" v-if="item.writeOffStatus == 'N' && item.quitProve">切結書</a>
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;"  @click="openBillingInvoice(item.id, item.idno, item.account, item.smtr, item.dormitoryType)"
                   v-else-if="item.writeOffStatus == 'N' && item.bankBarcode_1 && !item.quitProve && (new Date(item.paymentEndDate).setDate(new Date(item.paymentEndDate).getDate() + 1)) > new Date()">進入繳費</a>
                <span v-else-if="item.writeOffStatus == 'N' && item.bankBarcode_1 && !item.quitProve && (new Date(item.paymentEndDate).setDate(new Date(item.paymentEndDate).getDate() + 1)) <= new Date()">逾期繳費</span>
								<span v-else-if="item.writeOffStatus == 'Y'">{{item.writeOffStatusStr}}</span>
                <div v-if="accountType === 'STU' && item.writeOffStatus == 'N' && item.bankBarcode_1 && !item.quitProve">
                  <a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;"  @click="openWriteOffProve(item)">{{item.writeOffProveFile ? "繳費證明" : "上傳繳費證明"}}</a>
                </div>
							</td>
              <td class="text-center" data-title="繳費金額" >
                {{item.writeOffAmount ? item.writeOffAmount : ""}}
              </td>
              <td class="text-center" data-title="手動銷帳" v-if="isAdmin('stay')">
                <a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="item.writeOffStatus == 'N' && item.bankBarcode_1 && !item.quitProve" @click="openWriteOffProve(item)">手動銷帳</a>
                <span v-if="item.writeOffProveFile">{{item.writeOffStatus == 'N' ? "已上傳證明" : "銷帳完成"}}</span>
              </td>
							<td class="text-center" data-title="" v-if="accountType === 'STU'">
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="isIntoRoom(item) && item.isLeave != 'Y'" @click="gotoView('stay.intoRoomData', { id:item.id, idno: item.idno, account: item.account })">入宿</a>
							</td>
							<td class="text-center" data-title="" v-if="accountType === 'STU'">
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="isIntoRoom(item) && item.isLeave != 'Y'" @click="gotoView('stay.leave.apply', { leaveType:'C', id:item.id, idno: item.idno, account: item.account })">退宿申請</a>
								<span v-if="item.leaveType == 'C' && (item.leaveStatus && item.leaveStatus != 'N')">{{item.leaveStatus == 'Y' ? "退宿":"退宿申請中"}}</span>
							</td>
							<td class="text-center" data-title="" v-if="accountType === 'STU'">
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="isIntoRoom(item) && item.isLeave != 'Y' && leaveIsOpen" @click="gotoView('stay.leave.apply', { leaveType:'L', id:item.id, idno: item.idno, account: item.account })">離宿申請</a>
								<span v-if="item.leaveType == 'L' && (item.leaveStatus && item.leaveStatus != 'N')">{{item.leaveStatus == 'Y' ? "離宿":"離宿申請中"}}</span>
							</td>
						</tr>
						<tr v-if="item.writeOffStatus != 'Y' && item.bankBarcode_1 && accountType == 'STU'">
							<td colspan="15">
								<div class="col-md-12 table-bordered p-sm">
									<div class="form-group">
										<b>是否放棄入住宿舍?</b>
									</div>
								</div>
								<div class="col-md-12 table-bordered p-sm">
									<div class="form-group">
										<a href="javascript:;" target="_blank" style="color: #337ab7" @click="downloadFile('放棄住宿切結書.pdf')">放棄住宿切結書格式</a>
										, 請下載使用！
									</div>
								</div>
								<div class="col-md-12 table-bordered p-sm">
									<div class="form-group">
										<b>上傳放棄住宿切結書</b>
									</div>
								</div>
								<div class="col-md-12 table-bordered p-sm">
									<div class="form-group">
										<input type="file" name="quitProve" ref="quitProve" @change="getQuitProve($event, item)" />
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				</div>
				<div class="col-md-12">
					<div class="text-center" v-if="isAdmin('stay')">
						<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
					</div>
				</div>
			</div>
			</div>
		</div>
		<billingInvoicePopup v-if="isOpenBillingInvoice" v-bind:id="popupParam.id" v-bind:idno="popupParam.idno" v-bind:account="popupParam.account" v-bind:smtr="popupParam.smtr" v-bind:dormitoryType="popupParam.dormitoryType" />
    <stayWriteOffProve v-if="isOpenStayWriteOffProve" v-bind:id="popupParam.id" v-bind:writeOffProve="popupParam.writeOffProveFile" v-bind:writeOffType="popupParam.writeOffType" v-bind:totalAmount="popupParam.totalAmount" v-bind:writeOffDt="popupParam.writeOffDate"/>
	</div>
</template>
<script>
import billingInvoicePopup from './billingInvoice.vue';
import stayWriteOffProve from "@/components/popup/stayWriteOffProve";
export default {
	components:{
		billingInvoicePopup,
    stayWriteOffProve
	},
	data() {
		return {
			dormitoryType: "N",
			arimId: "",
			normalIsOpen: true,
			vacationIsOpen: true,
			specialIsOpen: true,
			leaveIsOpen:false,
			isDefault: true,
			importExcelFile: "",
			accountType: "",
			quitProveView: true,
			roomApplyList: {},
			quitProveFile: null,
			bed: "",
			bedList: [],
			account: "",
			smtr: "",
			idno: "",
			page: 1,
			totalPage: 1,
			isOpenBillingInvoice:false,
      isOpenStayWriteOffProve:false,
			popupParam:{
				id:"",
				idno:"",
				account:"",
				smtr:"",
				dormitoryType:"",
        writeOffProveFile:"",
        writeOffType:null,
        totalAmount:0,
        writeOffDate:''
			},
			bedFloor:"",
			bedRoom:"",
		};
	},
	mounted() {
		if (this.sessionData == null) {
			this.$router.replace({ path: "/" });
		}
		this.accountType = this.sessionData.accountType;
    //套用查詢設定
    const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));

    if(storeQryParam != null) {
      this.dormitoryType = storeQryParam.dormitoryType;
      this.bedFloor = storeQryParam.bedFloor;
      this.bedRoom = storeQryParam.bedRoom;
      this.smtr = storeQryParam.smtr;
      this.account = storeQryParam.account;
    }
    const storePage = this.getStore(`${this.$route.name}.page`);
    if(storePage != null) {
      this.page = storePage;
    }

    switch (this.dormitoryType) {
      case "V":
        document.querySelector("[id='dormitoryTypeNav']").children[1].classList.add("active");
        break;
      case "S":
        document.querySelector("[id='dormitoryTypeNav']").children[2].classList.add("active");
        break;
      case "N":
      default:
        document.querySelector("[id='dormitoryTypeNav']").children[0].classList.add("active");
        break;
    }
		this.itemIsOpening();
		this.selectionDoemitoryType(this.dormitoryType, false);

	},
	methods: {
		selectionDoemitoryType(dormitoryType, clearQueryParam = true) {
			this.dormitoryType = dormitoryType;
      if(clearQueryParam) {
        this.bedFloor = "";
        this.bedRoom = "";
        this.account = "";
        if(this.dormitoryType == "N"){
          this.smtr = this.nowSmtr;
        }else {
          this.smtr = `${this.nowSyear}`
        }
      } else {
        if(this.dormitoryType == "N" && (this.smtr.length != 4)){
          this.smtr = this.nowSmtr;
        }else if ((this.dormitoryType == "V" || this.dormitoryType == "S" ) && this.smtr.length != 3) {
          this.smtr = `${this.nowSyear}`
        }
      }
			this.loadGrid();
			this.getEmptyBedDoemitoryType();
		},
		loadGrid(){
			let qryParam = {};
			if (this.isAdmin('stay')) {
				qryParam = {
					smtr:this.smtr,
					dormitoryType: this.dormitoryType,
                    account:this.account,
                    bedFloor:this.bedFloor,
					bedRoom:this.bedRoom,
					applyStatus: "Y",
					qualification: "Q",

				};
			} else {
				qryParam = {
					account: this.sessionData.account,
					qualification: "Q",
					applyStatus: "Y"
				};
			}
			const api = "/api/Room/roomApplyList";
			let _this = this;
			this.$axios.post(api, JSON.stringify({
				model:qryParam,
				page: this.page,
				pageSize: 10,
				sortColumn:"BED_FLOOR, BED_ROOM, BED, BED_CATEGORY"
			})).then(resp => {
				_this.roomApplyList = resp.data.data;
				_this.totalPage = _this.roomApplyList.total;
				_this.page = _this.roomApplyList.page;
			});
		},
		itemIsOpening(){
			const apiSetting = "/api/Common/roomTimeSettingByType/";
			this.$axios.post(apiSetting).then(resp =>{
				if(resp.data.status == "success"){
					let tmp = resp.data.data.filter(item => {
						return item.key == "L"
					});
					if(tmp.length > 0){
						this.leaveIsOpen = tmp[0].value == "Y";
					}
				}
			});
		},
		changeBed(data, event) {
			const api = `/api/Room/intoRoomDataChangeBed/${event.target.value}/${data.id}`;
			this.$axios.post(api).then(resp => {
				if (resp.data.status === "success") {
					bootbox.alert(resp.data.msg);
				} else {
					bootbox.alert(resp.data.msg);
				}
				this.selectionDoemitoryType(this.dormitoryType);
			});
		},
		getEmptyBedDoemitoryType() {
			const qryParamBed = {
				dormitoryType: this.dormitoryType
			};
			const api = "/api/Room/roomDataByEmptyBed";
			this.$axios.post(api, qryParamBed).then(resp => {
				this.bedList = resp.data.data;
			});
		},

		setDoemitoryType(dormitoryType) {
			this.dormitoryType = dormitoryType;
		},
		updateGrid(page) {
			this.page = page;
			this.loadGrid();
		},
		uploadFile(e) {
			this.importExcelFile = "";
			this.importExcelFile = e.target.files[0];
			this.importExcel(e);
		},
		importExcel(e) {
			const api = "/api/Room/importIntoRoomExcel";
			let formData = new FormData();
			formData.append("file", this.importExcelFile);
			formData.append("dormitoryType",this.dormitoryType);
			this.$axios.post(api, formData).then(resp => {
				if (resp.data.status === "success") {
					bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
				} else {
					bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
				}
				this.selectionDoemitoryType(this.dormitoryType);
			});
			e.target.value = "";
		},
		exportExcel() {
			const api = "/api/Room/exportIntoRoomExcel";
			this.$axios.post( api, JSON.stringify({
				dormitoryType: this.dormitoryType,
        smtr: this.smtr,
			}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "房間分配_"+this.customFormatter(new Date(),"YYYYMMDD")+".xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},
		exportBankText(){
			const api = "/api/Room/exportToBankTxt/"+this.dormitoryType;
			this.$axios.post( api, JSON.stringify({}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "銀行_"+this.customFormatter(new Date(),"YYYYMMDD")+".txt");
				document.body.appendChild(link);
				link.click();
			});
		},
		getQuitProve(e, item) {
			this.quitProveFile = null;
			this.quitProveFile = e.target.files[0];
			this.uploadFileQuitProve(e, item);
		},
		uploadFileQuitProve(e, item) {
			const api = `/api/Room/giveUpRoomApply/${item.id}`;
			let formData = new FormData();
			formData.append("quitProveFile", this.quitProveFile);
			this.$axios.post(api, formData).then(resp => {
				if (resp.data.status === "success") {
					bootbox.alert(resp.data.msg);
					this.selectionDoemitoryType(this.dormitoryType);
				} else {
					bootbox.alert(resp.data.msg);
				}
			});

			e.target.value = "";
		},
		openBillingInvoice(id, idno, account, smtr, dormitoryType){
			this.popupParam.id = id;
			this.popupParam.idno = idno;
			this.popupParam.account=account;
			this.popupParam.smtr = smtr;
			this.popupParam.dormitoryType=dormitoryType;
			this.showPopupControl(true);
		},
		showPopupControl(isOpen){
			this.isOpenBillingInvoice = isOpen;
		},
		isIntoRoom(item){
			return item.writeOffStatus == "Y" && item.isLeave == "N";
		},
    openWriteOffProve(item){
      this.popupParam.id = item.id;
      this.popupParam.writeOffProveFile = item.writeOffProveFile;
      this.popupParam.writeOffType = item.writeOffType;
      this.popupParam.totalAmount = item.roomAmt + item.ensureAmt;
      this.popupParam.writeOffDate = item.writeOffDate;
      this.isOpenStayWriteOffProve = true;
    },
		getDormitoryTypeStr(dormitoryType){
			let str = "";
			if(dormitoryType == "N"){
				str = "一般宿舍";
			}else if(dormitoryType == "S"){
				str = "特殊宿舍";
			}else if(dormitoryType == "V"){
				str = "寒暑假宿舍";
			}
			return str;
		},
		selectYear(){
			let smtrArray = [];
			for(let y = parseInt(this.applySmtr.substring(0,3)); y > 107 ; y--){
				if(this.dormitoryType == "N"){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
					smtrArray.push({text:y+"年第一學期",value:y+"1"});
				}else{
					smtrArray.push({text:y+"年",value:`${y}`});
				}
			}
			return smtrArray;
		},
	},
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name === "stay.leave.apply" || to.name === "stay.intoRoomData") {
      this.setStore(`${this.$route.name}.qryParam`, {
        dormitoryType: this.dormitoryType,
        smtr: this.smtr,
        account: this.account,
        bedFloor :this.bedFloor,
        bedRoom: this.bedRoom
      });
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    this.removeStore(this.$route.name);
    next();
  }
};
</script>
